'use strict';

/**
 * Renders a modal window that will track the users consenting to accepting site tracking policy
 */
var _this = this;
var consent = {
  getString: function getString(urlAccept) {
    //immediately return a calculate string value
    return "<div class=\"consent-drawer\" id=\"consent-tracking\" role=\"dialog\" data-url-accept=\"".concat(urlAccept, "\"></div>");
  },
  showConsentDrawer: function showConsentDrawer($trackingElement) {
    if ([undefined, null].indexOf($trackingElement) !== -1 || !$trackingElement.data('caonline')) {
      return;
    }
    var namespace = '.consenttrackingdrawer ',
      urlAccept = $trackingElement.data('accept');
    var htmlString = consent.getString(urlAccept);
    $('body').append(htmlString);
    var $consentTracking = $('#consent-tracking');
    var $consentContent = $('#consent-content');
    $consentTracking.append($consentContent.children()); // Move to $consentTracking

    $consentTracking.find('.button-accept').on('click' + namespace, function (event) {
      event.preventDefault();
      var url = $(event.target).closest('[data-url-accept]').data('url-accept');
      $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        context: $consentTracking,
        complete: function complete() {
          this.remove();
        },
        error: function error() {
          this.remove();
        }
      });
    });
  },
  init: function init() {
    var namespace = '.consenttracking ',
      $trackingConsent = $('.tracking-consent');
    if ($('.consented').length === 0 && $trackingConsent.hasClass('api-true')) {
      consent.showConsentDrawer($trackingConsent);
    }
    $trackingConsent.each(function (index, element) {
      var $this = $(_this);
      if ($this.hasClass('api-true')) {
        $this.on('click' + namespace, function () {
          consent.showConsentDrawer($this);
        });
      }
    });
  }
};
module.exports = consent;